import { render } from "./biddings-page.vue?vue&type=template&id=d87257ba&ts=true"
import script from "./biddings-page.vue?vue&type=script&lang=ts"
export * from "./biddings-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__